import * as React from "react";
import "../../../assets/scss/components/toc/fundTransfer/ftFaqLink.scss";

export interface IFtFaqLinkProps {}

const FtFaqLink: React.FC<IFtFaqLinkProps> = () => {
	return (
		<div className="faq_link_wrap">
			<div className="ft_faq_icon"></div>
			<p className="faq_help">Need Help?</p>
			<h2 className="faq_msg">Check FAQs for fund transfer</h2>
		</div>
	);
};

export default FtFaqLink;
